/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";

import Text from "../Text";

import s from "./Label.module.css";

export interface ILabel {
  children: React.ReactNode;
  htmlFor?: string;
  isRequired?: boolean;
  variant?: "light" | "dark" | "special";
  size?: "large" | "medium" | "small";
  className?: string;
  note?: string;
  hasMargin?: boolean;
  isBold?: boolean;
  noteProps?: any;
}

const Label = ({
  children,
  htmlFor,
  isRequired,
  variant = "light",
  size = "small",
  className,
  note,
  hasMargin = true,
  isBold = true,
  noteProps,
}: ILabel) => {
  const marginClass = {
    "mb-2": hasMargin && (size === "large" || size === "medium"),
    "mb-1": hasMargin && size === "small",
  };

  return (
    <div className={cn(marginClass)} test-id="3lMTgCQe">
      <label
        htmlFor={htmlFor}
        className={cn(
          s.root,
          variant && s[variant],
          size && s[size],
          className,
          {
            ...marginClass,
            "font-medium": isBold,
            "cursor-pointer": !!htmlFor,
          },
        )}
        test-id="CjZjZl12"
      >
        {children}
        {isRequired && (
          <span className="text-alert" test-id="ks0p5unJ">
            *
          </span>
        )}
      </label>

      {note && (
        <Text
          className={cn(
            "text-xs",
            noteProps?.className,
            {
              "text-warning": !noteProps?.className.includes("text-"),
            },
            // size === "large" && hasMargin && "-mt-2 mb-1"
          )}
          test-id="H7M6DwY0"
        >
          {note}
        </Text>
      )}
    </div>
  );
};

export default Label;
